import { NotificationCategory } from '@/types'

export enum NotificationSource {
    feed = 'feed',
    chat = 'chat',
}

export interface NotificationActor {
    id: string
    name?: string
    image?: string
}

// The parts of a Stream feed activity and chat channel that a notification is made from

export interface NotificationActivity {
    id: string
    text?: string
    custom: { title?: string }
    created_at: Date
    user: NotificationActor
}

export interface NotificationChannelMessage {
    text?: string
    created_at?: Date
    user?: NotificationActor | null
}

export interface NotificationChannel {
    id?: string
    cid: string
    data?: unknown
    state: {
        members: Record<string, { user?: NotificationActor }>
        latestMessages: NotificationChannelMessage[]
        last_message_at?: Date | null
    }
    countUnread: () => number
    getClient: () => { userID?: string }
}

export interface NotificationItem {
    id: string
    source: NotificationSource
    category: NotificationCategory
    title: string
    body?: string
    createdAt: Date
    read: boolean
    // Number of unread messages it stands for, when that can be more than one (a conversation)
    unreadCount?: number
    actor?: NotificationActor
}
